<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <template v-slot:activator="{on, attrs}">
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="isDisabled"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        Desvincular
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Desvincular terminal?
      </v-card-title>
      <v-card-text>
        <form-group>
          <v-textarea
            v-model="reason"
            label="Motivo"
            rows="5"
            outlined
          />
        </form-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          id="closeBtn"
          outlined
          color="primary"
          @click="handleModal()"
        >
          Cancelar
        </v-btn>
        <v-btn
          id="send"
          class="white--text ml-2"
          color="#2ABD49"
          :loading="loading"
          @click.prevent="unlink()"
        >
          Desvincular
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DataTableTextColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableTextColumn.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import PosRequest from '../PosRequest';

export default {
  name: 'StoreUnlinkTerminal',
  components: { FormGroup },
  extends: DataTableTextColumnVue,
  mixins: [ServiceMixin],
  props: {
    row: {
      type: Object,
      default() {
        return {
          id: '',
          status: '',
          loja: {
            id: '',
          },
        };
      },
    },
  },
  data: () => ({
    request: PosRequest,
    loading: false,
    dialog: false,
    reason: '',
  }),
  computed: {
    payload() {
      return {
        storeId: this.row.loja.id,
        posTerminalId: this.row.id,
        reason: this.reason,
      };
    },
    isDisabled() {
      return this.row.status === 'DISPONIVEL';
    },
  },
  methods: {
    handleModal() {
      this.dialog = !this.dialog;
    },
    unlink() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.request.unlink(
          this.payload,
        ),
        (success) => {
          this.handleLoading();
          if (success) {
            this.$root.$emit('refresh-crud-PosCrudList', true);
          }
        },
      );
    },
  },
};
</script>
